import {fsaPayload, fsaError} from './helpers'

export const GET_GRF_QUALIFICATION_STATUS_FAILURE =
  'get groom rents free qualification status failure'
export const getGrfQualificationStatusFailure = fsaError(GET_GRF_QUALIFICATION_STATUS_FAILURE)

export const GET_GRF_QUALIFICATION_STATUS_SUCCESS =
  'get groom rents free qualification status success'
export const getGrfQualificationStatusSuccess = fsaPayload(GET_GRF_QUALIFICATION_STATUS_SUCCESS)
